// Copyright © 2007-2023 David Caldwell <david@greenfelt.net>

function point_scale(k, p) {
    return { x:k*p.x, y:k*p.y };
}

function point_sum(a, b) {
    return { x:a.x + b.x, y:a.y + b.y };
}

function polar_to_cartesian(p) {
    return { x:p.r*Math.cos(p.theta), y:p.r*Math.sin(p.theta) };
}

function point_difference(to, from) {
    return { x:to.x - from.x, y:to.y - from.y };
}

function point_dot(a, b) {
    return a.x * b.x + a.y * b.y;
}

function point_cross(a, b) {
    return a.x * b.y - b.x * a.y;
}

function point_norm(z) {
    return z.x * z.x + z.y * z.y;
}

function point_squared_distance(a, b) {
    return point_norm(point_difference(a,b));
}

function point_distance(a, b) {
    return Math.sqrt(point_norm(point_difference(a,b)));
}

function point_det(p0, p1, p2) {
    return point_cross(point_difference(p0,p2), point_difference(p1,p2)); // | p0 p1 p2 |
}

function signed_distance_to_line(p, z1, z2) {
    return point_det(p,z1,z2) / point_distance(z1,z2);
}

function distance_to_line(p, z1, z2) {
    return Math.abs(signed_distance_to_line(p, z1, z2));
}

function distance_to_line_segment(p, z1, z2) {
    var z = point_difference(z2,z1);
    var a = point_difference(p,z1);
    var adotz = point_dot(a,z), zdotz = point_dot(z,z);
    if (adotz <= 0)
        return Math.sqrt(point_norm(a));
    if (adotz >= zdotz)
        return Math.sqrt(point_norm(point_difference(p,z2)));
    return distance_to_line(p,z1,z2);
}

// https://stackoverflow.com/questions/75150926/how-does-the-line-intersection-routine-in-the-greiner-hormann-algorithm-work
function lines_intersect(p1, p2, q1, q2) {
    let wec_p1 = signed_distance_to_line(p1, q1, q2);
    let wec_p2 = signed_distance_to_line(p2, q1, q2);
    if (wec_p1 * wec_p2 > 0)
        return false;
    let wec_q1 = signed_distance_to_line(q1, p1, p2);
    let wec_q2 = signed_distance_to_line(q2, p1, p2);
    if (wec_q1 * wec_q2 > 0)
        return false;
    return [ wec_p1/(wec_p1 - wec_p2),
             wec_q1/(wec_q1 - wec_q2) ];
}

function percentage_along_line(p1, p2, a) {
    return point_sum(p1, point_scale(a, point_difference(p2, p1)));
}

module.exports = {
    point_scale:               point_scale,
    point_sum:                 point_sum,
    polar_to_cartesian:        polar_to_cartesian,
    point_difference:          point_difference,
    point_dot:                 point_dot,
    point_cross:               point_cross,
    point_norm:                point_norm,
    point_squared_distance:    point_squared_distance,
    point_distance:            point_distance,
    point_det:                 point_det,
    signed_distance_to_line:   signed_distance_to_line,
    distance_to_line:          distance_to_line,
    distance_to_line_segment:  distance_to_line_segment,
    lines_intersect:           lines_intersect,
    percentage_along_line:     percentage_along_line,
}
// Copyright © 2007-2023 David Caldwell <david@greenfelt.net>

function point_scale(k, p) {
    return { x:k*p.x, y:k*p.y };
}

function point_sum(a, b) {
    return { x:a.x + b.x, y:a.y + b.y };
}

function polar_to_cartesian(p) {
    return { x:p.r*Math.cos(p.theta), y:p.r*Math.sin(p.theta) };
}

function point_difference(to, from) {
    return { x:to.x - from.x, y:to.y - from.y };
}

function point_dot(a, b) {
    return a.x * b.x + a.y * b.y;
}

function point_cross(a, b) {
    return a.x * b.y - b.x * a.y;
}

function point_norm(z) {
    return z.x * z.x + z.y * z.y;
}

function point_squared_distance(a, b) {
    return point_norm(point_difference(a,b));
}

function point_distance(a, b) {
    return Math.sqrt(point_norm(point_difference(a,b)));
}

function point_det(p0, p1, p2) {
    return point_cross(point_difference(p0,p2), point_difference(p1,p2)); // | p0 p1 p2 |
}

function signed_distance_to_line(p, z1, z2) {
    return point_det(p,z1,z2) / point_distance(z1,z2);
}

function distance_to_line(p, z1, z2) {
    return Math.abs(signed_distance_to_line(p, z1, z2));
}

function distance_to_line_segment(p, z1, z2) {
    var z = point_difference(z2,z1);
    var a = point_difference(p,z1);
    var adotz = point_dot(a,z), zdotz = point_dot(z,z);
    if (adotz <= 0)
        return Math.sqrt(point_norm(a));
    if (adotz >= zdotz)
        return Math.sqrt(point_norm(point_difference(p,z2)));
    return distance_to_line(p,z1,z2);
}

// https://stackoverflow.com/questions/75150926/how-does-the-line-intersection-routine-in-the-greiner-hormann-algorithm-work
function lines_intersect(p1, p2, q1, q2) {
    let wec_p1 = signed_distance_to_line(p1, q1, q2);
    let wec_p2 = signed_distance_to_line(p2, q1, q2);
    if (wec_p1 * wec_p2 > 0)
        return false;
    let wec_q1 = signed_distance_to_line(q1, p1, p2);
    let wec_q2 = signed_distance_to_line(q2, p1, p2);
    if (wec_q1 * wec_q2 > 0)
        return false;
    return [ wec_p1/(wec_p1 - wec_p2),
             wec_q1/(wec_q1 - wec_q2) ];
}

function percentage_along_line(p1, p2, a) {
    return point_sum(p1, point_scale(a, point_difference(p2, p1)));
}

module.exports = {
    point_scale:               point_scale,
    point_sum:                 point_sum,
    polar_to_cartesian:        polar_to_cartesian,
    point_difference:          point_difference,
    point_dot:                 point_dot,
    point_cross:               point_cross,
    point_norm:                point_norm,
    point_squared_distance:    point_squared_distance,
    point_distance:            point_distance,
    point_det:                 point_det,
    signed_distance_to_line:   signed_distance_to_line,
    distance_to_line:          distance_to_line,
    distance_to_line_segment:  distance_to_line_segment,
    lines_intersect:           lines_intersect,
    percentage_along_line:     percentage_along_line,
}
